import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import BeautyTest from "@/pages/BeautyTest";
import Analysis from "@/pages/Analysis";
import SkinProfile from "@/pages/SkinProfile";
import Routine from "@/pages/Routine";
import AdminLogin from "@/pages/admin/AdminLogin";
import AuthCallback from "@/pages/admin/AuthCallback";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminChat from "@/pages/admin/AdminChat";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminConsultant from "@/pages/admin/AdminConsultant";
import AdminRules from "@/pages/admin/AdminRules";
import EntityManager from "@/pages/admin/EntityManager";
import { ENTITIES } from "@/pages/admin/entityConfigs";
import { ChatWidget } from "@/components/chat/ChatWidget";
import { captureUtm } from "@/lib/tracking";

captureUtm();

function AppRouter() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  useEffect(() => {
    // Manifest PWA diverso per area admin: "Aggiungi a schermata Home" dal pannello installa il pannello, non il sito clienti
    const link = document.getElementById("app-manifest");
    if (link) link.href = isAdmin ? "/manifest-admin.json" : "/manifest.json";
    document.title = isAdmin ? "FineSkin Beauty – Pannello admin" : "FineSkin Beauty – La mia routine";
  }, [isAdmin]);
  // Detect OAuth return synchronously, before any protected route runs
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/test" element={<BeautyTest />} />
      <Route path="/analisi" element={<Analysis />} />
      <Route path="/profilo" element={<SkinProfile />} />
      <Route path="/routine" element={<Routine />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminAnalytics />} />
        {ENTITIES.map((e) => (
          <Route key={e.path} path={e.path} element={<EntityManager key={e.coll} config={e} />} />
        ))}
        <Route path="impostazioni" element={<AdminSettings />} />
        <Route path="chat" element={<AdminChat />} />
        <Route path="clienti" element={<AdminLeads />} />
        <Route path="consulente" element={<AdminConsultant />} />
        <Route path="regole-routine" element={<AdminRules />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    {!isAdmin && <ChatWidget />}
    </>
  );
}

export default function App() {
  return (
    <div className="App fs-grain">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}
